import React from 'react';
import { useDropzone } from 'react-dropzone';
import { Paper, Box, IconButton, Typography } from '@mui/material';
import { CloudUpload as UploadIcon } from '@mui/icons-material';

export const LogoDropzone = ({ onDrop }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/*': ['.png', '.jpg', '.jpeg', '.gif', '.svg'],
    },
    maxFiles: 1,
  });

  return (
    <Paper
      variant='outlined'
      sx={{
        p: 3,
        cursor: 'pointer',
        textAlign: 'center',
        bgcolor: isDragActive ? 'action.hover' : 'transparent',
        borderStyle: 'dashed',
        borderColor: 'grey.500',
        '&:hover': {
          bgcolor: 'action.hover',
        },
      }}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <IconButton size='large' disabled>
          <UploadIcon />
        </IconButton>
        <Typography variant='body1' sx={{ mt: 1 }}>
          {isDragActive ? 'Drop the file here' : 'Drag & drop a logo file, or click to select'}
        </Typography>
        <Typography variant='caption' color='text.secondary' sx={{ mt: 0.5 }}>
          PNG, JPG, GIF or SVG (max. 5MB)
        </Typography>
      </Box>
    </Paper>
  );
};
